const PAGE_URLS =  {
  HOME: ["/shop", "/"],
};

export default PAGE_URLS;